import { createApp } from 'vue'
import App from './App.vue'
// import VConsole from 'vconsole'
// const v = new VConsole()
// v.show()
createApp(App).mount('#app')
